// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".delete-btn[data-v-cf54ae16]{border:1px solid rgba(0,0,0,0);background-color:rgba(187,34,0,.9333333333) !important;-webkit-box-shadow:none;box-shadow:none}", ""]);
// Exports
module.exports = exports;
